// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FClxZ","Section_2":"styles_Section_2__ohGuW"};